import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { LaasOption } from 'src/app/core/models/laas-option';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { EnvironmentMonitorService } from '../../service/environment-monitor.service';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { endOfDay, startOfDay } from 'date-fns';

@Component({
  selector: 'laas-environment-monitor',
  templateUrl: './environment-monitor.component.html',
  styleUrls: ['./environment-monitor.component.scss'],
})
export class EnvironmentMonitorComponent
  extends SessionBaseComponent
  implements OnInit
{
  @ViewChild('MonitorDt') monitorDt!: CalendarComponent;
  readonly permissionCode = PermissionConstants.ViewEnvironmentMonitorComponent;
  currentLang: string = this.laasSetting.language;
  preferenceKey: string = UserPreferenceConstants.EnvironmentMonitorTableData;

  isSearchFormOpen: boolean = true;
  isLoading: boolean = false;

  searchForm: FormGroup;
  searchParams: any;
  searchSensorInfoOptionsRequest: any;
  results: any;
  columns: any[];
  defaultMonitorDt: Date[];

  facilityOptions: LaasOption[] = [];
  floorOptions: any[] = [];
  areaOptions: any[] = [];

  @ViewChild('table') table!: DataTableComponent;

  constructor(
    injector: Injector,
    private formBuilder: FormBuilder,
    private dropdownOptionsService: DropdownOptionsService,
    private environmentMonitorService: EnvironmentMonitorService
  ) {
    super(injector);

    this.defaultMonitorDt = [startOfDay(new Date()), endOfDay(new Date()) ];

    this.searchForm = this.formBuilder.group({
      facility: 'LK',
      floor: null,
      area: null,
      monitorDtStart: this.defaultMonitorDt[0],
      monitorDtEnd: this.defaultMonitorDt[1],
    });

    this.searchParams = {
      facility: 'LK',
      floor: null,
      area: null,
      monitorDtStart: this.defaultMonitorDt[0],
      monitorDtEnd: this.defaultMonitorDt[1],
    };

    this.searchSensorInfoOptionsRequest = {
      facility: 'LK',
      floor: null,
      area: null
    }

    this.columns = [
      { field: 'floorName', header: 'EnvironmentMonitor.TableColumn.Floor', sort: true },
      { field: 'areaName', header: 'EnvironmentMonitor.TableColumn.Area', sort: true },
      { field: 'monitorDt', header: 'EnvironmentMonitor.TableColumn.MonitorDt', sort: true },
      { field: 'temperature', header: 'EnvironmentMonitor.TableColumn.Temperature', sort: true },
      { field: 'humidity', header: 'EnvironmentMonitor.TableColumn.Humidity', sort: true },
    ];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (result) => {
        this.facilityOptions = [...result].map((x: any) => {
          return {
            value: x.optionCode,
            label: x.optionDesc,
          };
        });
      },
    });

    this.getSensorFloorOptions();
  }

  searchBtnClick() {

    this.searchParams = this.searchForm.value;

    if (isNullOrEmpty(this.searchParams.monitorDtStart)) {
      this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFields'));
      return;
    }

    this.isLoading = true;
    this.isSearchFormOpen = false;

    this.environmentMonitorService
      .searchEnvironmentMonitor(this.searchParams)
      .subscribe({
        next: (result) => {
          this.results = result;
          this.table.updateTableData(this.results);
        },
        error: (err: any) => {
          this.toastErrorMessage(err.error);
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  resetBtnClick() {
    this.searchForm.reset();
    this.searchForm.controls.monitorDtStart.setValue(this.defaultMonitorDt[0]);
    this.searchForm.controls.monitorDtEnd.setValue(this.defaultMonitorDt[1]);
    this.searchParams.monitorDtStart = this.defaultMonitorDt[0];
    this.searchParams.monitorDtEnd = this.defaultMonitorDt[1];
    this.monitorDt.changeShowDate([this.defaultMonitorDt[0], this.defaultMonitorDt[1]]);
    console.log(this.defaultMonitorDt[0]);
    console.log(this.searchParams.monitorDtStart);
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'monitorDt':
        this.searchForm.controls.monitorDtStart.setValue(date.startDate);
        this.searchForm.controls.monitorDtEnd.setValue(date.endDate);
        break;
    }
  }

  getSensorFloorOptions() {
    this.environmentMonitorService
      .getSensorFloorOptions(this.searchSensorInfoOptionsRequest)
      .subscribe({
        next: (result) => {
          this.floorOptions = [...result].map((x: any) => {
            return {
              value: x,
              label: x,
            };
          });
        },
        complete: () => {
          this.searchForm.controls['floor'].setValue(null);
          this.searchParams.floor = null;
        },
      });
  }

  getSensorAreaOptions() {
    this.environmentMonitorService
      .getSensorAreaOptions(this.searchSensorInfoOptionsRequest)
      .subscribe({
        next: (result) => {
          this.areaOptions = [...result].map((x: any) => {
            return {
              value: x,
              label: x,
            };
          });
        },
        complete: () => {
          this.searchForm.controls['area'].setValue(null);
          this.searchParams.area = null;
        },
      });
  }

  optionsDataOnChange(data: any, type: string): void {
    switch (type) {
      case 'facility':
        this.searchSensorInfoOptionsRequest.facility = data;
        this.getSensorFloorOptions();
        break;
    }
  }
}
